import styled from 'styled-components';

export const Container = styled.div`
  .attachments-header {
    background: ${(props) => props.theme.$gray200};
    color: ${(props) => props.theme.$gray700};
    font-weight: bold;
  }

.long-text {
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

}
`;
